import { render, staticRenderFns } from "./gift_list_2.vue?vue&type=template&id=5ddfce56&scoped=true"
import script from "./gift_list_2.vue?vue&type=script&lang=js"
export * from "./gift_list_2.vue?vue&type=script&lang=js"
import style0 from "./gift_list_2.vue?vue&type=style&index=0&id=5ddfce56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfce56",
  null
  
)

export default component.exports